/**
 * The current version, in semver.
 * @type {String}
 */
export const VERSION = "2026.05.07";
